<div style="position: relative; display: inline-block; overflow: hidden; border-radius: 2rem; vertical-align: middle">
  <div class="volume-indicator-fill" [style.height.%]="noiseLevel()"> </div>
  <p-button
    class="mic-btn"
    (click)="initStopMicState()"
    [icon]="micStateService.icon()"
    [rounded]="true"
    [severity]="micStateService.severity()"
    [disabled]="isDone()"></p-button>

  <!-- {{ noiseLevel() }} Removed, visual indicator is the fill -->
  @if (micSettings.micMode === 'recording') {
  <span style="position: absolute; top: -5px; right: -10px; z-index: 3"> 🎤 </span>
  } @if (micSettings.micMode === 'recognition') {
  <span style="position: absolute; top: -5px; left: -10px; z-index: 3"> 🦻 </span>
  }
  <!-- Consider if this text needs z-index or repositioning -->

  <!-- <span style="position: absolute; bottom: -5px; z-index: 3"> 🇺🇸 </span> -->
</div>

<!-- Estado: {{ micServiceService.status() }} -->
